export const elearningFormationData = {
  vtc: {
    type: "VTC",
    lesson: "Formation VTC en ligne - 549 €",
    backSection: "vtc",
    eyebrow: "Formation VTC e-learning",
    h1: "Formation VTC en ligne : préparez votre examen à votre rythme.",
    heroIntro:
      "Cours en ligne, entraînements, suivi pédagogique et préparation pratique : avancez vers votre carte professionnelle avec une organisation adaptée à votre quotidien.",
    heroAlt:
      "Candidat suivant sa formation VTC en ligne sur ordinateur et smartphone",
    offerTitle: "Une formation VTC e‑learning complète à 549 €",
    offerIntro:
      "Cette formule réunit la <strong>préparation à l'examen VTC</strong>, la pratique et les frais d'examen dans un tarif clair. Vous travaillez en autonomie tout en gardant un parcours balisé jusqu'au jour des épreuves.",
    offerDetail:
      "L'accès aux contenus permet de revoir chaque matière autant de fois que nécessaire. Une fois la théorie consolidée, la formation pratique avec véhicule vous aide à transférer vos connaissances vers les attentes concrètes de l'épreuve d'admission.",
    offerBenefits: [
      "Préparation théorique en e-learning",
      "Formation pratique avec véhicule",
      "Frais d'examen inclus",
      "Cours, modules de révision, quiz et examens blancs",
      "Jeux pédagogiques et suivi de progression",
    ],
    firstFeatures: [
      {
        title: "Des cours VTC en ligne accessibles à votre rythme",
        image: "vtc-elearning1.webp",
        alt: "Cours VTC en ligne accessibles depuis un ordinateur portable",
        copy: "Connectez-vous à vos <strong>cours VTC en ligne</strong> quand votre emploi du temps le permet. Sur ordinateur comme sur smartphone, les modules restent disponibles pour reprendre une notion, réviser entre deux activités ou organiser plusieurs sessions courtes dans la semaine. Cette flexibilité fait de la <strong>formation VTC e-learning</strong> une solution adaptée aux candidats qui souhaitent conserver leur activité tout en préparant leur projet professionnel.",
        detail:
          "Vous n'êtes pas obligé de parcourir tout le programme d'une traite. Vous pouvez alterner découverte d'un chapitre, prise de notes et entraînement, puis revenir sur les notions moins bien assimilées. Cette progression régulière favorise une mémorisation durable et permet de construire une méthode de travail réaliste, même avec un planning chargé.",
        bullets: [
          "Accès aux modules depuis un ordinateur ou un smartphone",
          "Révisions possibles le soir, le week-end ou entre deux activités",
          "Reprise libre des chapitres qui demandent davantage de travail",
        ],
      },
      {
        title: "Une préparation à l'examen VTC centrée sur les bonnes matières",
        image: "vtc-elearning2.webp",
        alt: "Préparation à l'examen VTC avec des modules de révision en ligne",
        copy: "La <strong>préparation à l'examen VTC</strong> couvre le tronc commun T3P : réglementation du transport public particulier de personnes, gestion, sécurité routière, français et anglais. Elle traite aussi les matières propres à l'activité VTC, notamment son cadre réglementaire, son développement commercial et sa gestion. Chaque chapitre vous aide à comprendre les attentes des QCM et QRC avant de passer aux entraînements chronométrés.",
        detail:
          "Le parcours distingue clairement les connaissances communes aux professions T3P des compétences propres au chauffeur VTC. Vous travaillez notamment la relation commerciale, la construction d'une offre de service et les règles qui encadrent l'exploitation d'une activité VTC. Des rappels synthétiques facilitent les révisions avant chaque série de questions.",
        bullets: [
          "Tronc commun T3P et réglementation du transport de personnes",
          "Gestion, sécurité routière, français et anglais",
          "Développement commercial et réglementation spécifique VTC",
        ],
      },
    ],
    ctaTitle: "Préparez votre examen VTC dès maintenant",
    ctaCopy:
      "Accédez à la formation VTC en ligne pour 549 €, ou réglez 4 × 137,25 € sans frais.",
    secondFeatures: [
      {
        title: "Des quiz et des jeux pour ancrer vos acquis VTC",
        image: "vtc-elearning3.webp",
        alt: "Quiz et jeux pédagogiques de la formation VTC e-learning",
        copy: "Testez vos connaissances avec des QCM, des examens blancs et des séries ciblées par matière. Les jeux pédagogiques, défis et classements apportent un rythme plus vivant aux révisions et vous encouragent à pratiquer régulièrement. Vous pouvez ainsi vérifier vos automatismes, revenir sur une erreur et vous familiariser avec le format attendu lors de l'examen VTC.",
        detail:
          "Les entraînements ne servent pas seulement à compter les bonnes réponses : ils vous apprennent à lire précisément un énoncé, à gérer le temps disponible et à repérer les formulations qui peuvent prêter à confusion. Les défis courts complètent les sessions longues pour maintenir une pratique fréquente sans rendre les révisions monotones.",
        bullets: [
          "QCM par thème et séries de révision ciblées",
          "Examens blancs pour se rapprocher des conditions réelles",
          "Jeux, défis et classements pour entretenir la régularité",
        ],
      },
      {
        title: "Un suivi précis de votre progression jusqu'à l'examen VTC",
        image: "vtc-elearning4.webp",
        alt: "Tableau de suivi de progression pour l'examen VTC en ligne",
        copy: "Votre tableau de bord rassemble vos statistiques, vos notes et vos résultats aux entraînements. La progression par matière met en évidence les thèmes maîtrisés et les points à retravailler. Vous ajustez ainsi vos priorités au fil de la <strong>formation VTC en ligne</strong> et abordez l'examen avec une vision claire de votre niveau.",
        detail:
          "Au lieu de réviser toutes les matières de la même manière, vous vous appuyez sur des résultats concrets pour organiser la suite. Une baisse de score en gestion ou en réglementation devient immédiatement visible. Vous pouvez alors reprendre le cours correspondant, refaire une série ciblée et vérifier que la notion est réellement acquise.",
        bullets: [
          "Notes et taux de réussite visibles après les entraînements",
          "Progression détaillée matière par matière",
          "Identification rapide des thèmes à reprendre avant l'examen",
        ],
      },
    ],
  },
  taxi: {
    type: "Taxi",
    lesson: "Formation Taxi en ligne - 549 €",
    backSection: "taxi",
    eyebrow: "Formation Taxi e-learning",
    h1: "Formation Taxi en ligne : préparez votre examen à votre rythme.",
    heroIntro:
      "Préparez les matières théoriques à distance, mesurez vos acquis et entraînez-vous à la conduite avec le véhicule prévu dans la formule.",
    heroAlt: "Candidat préparant l'examen Taxi avec une formation en ligne",
    offerTitle: "Un parcours Taxi en ligne complet pour 549 €",
    offerIntro:
      "La formule associe <strong>formation Taxi e-learning</strong>, accompagnement pratique avec véhicule et frais d'examen inclus. Le parcours vous guide des premières révisions jusqu'à la préparation de la mise en situation professionnelle.",
    offerDetail:
      "Vous disposez d'un cadre de travail complet pour comprendre le fonctionnement de l'activité taxi, consolider les matières de l'admissibilité et préparer ensuite les gestes, décisions et attitudes attendus pendant l'épreuve pratique.",
    offerBenefits: [
      "Préparation théorique en e-learning",
      "Formation pratique avec véhicule",
      "Frais d'examen inclus",
      "Cours, modules de révision, quiz et examens blancs",
      "Jeux pédagogiques et suivi de progression",
    ],
    firstFeatures: [
      {
        title: "Organisez vos cours Taxi en ligne selon vos disponibilités",
        image: "vtc-elearning1.webp",
        alt: "Cours Taxi en ligne consultés à son rythme sur ordinateur",
        copy: "La plateforme vous permet d'avancer sans dépendre d'un horaire de classe. Vos <strong>cours Taxi en ligne</strong> sont consultables sur ordinateur ou smartphone pour réviser chez vous, pendant une pause ou lors d'un déplacement. Vous choisissez le rythme de vos séances et reprenez facilement un module. Cette organisation convient particulièrement aux personnes en reconversion ou déjà engagées dans une activité professionnelle.",
        detail:
          "Chaque candidat peut construire un calendrier adapté à sa date d'examen et à ses contraintes. Une matière dense peut être découpée en plusieurs séances, tandis qu'un chapitre déjà maîtrisé peut être validé plus rapidement. Les contenus restent disponibles pour relire une règle locale, vérifier une notion de gestion ou reprendre un exercice sans attendre un prochain cours en salle.",
        bullets: [
          "Plateforme accessible à distance sur les principaux écrans",
          "Séances de travail organisées selon vos disponibilités",
          "Retour immédiat vers un cours après une erreur d'entraînement",
        ],
      },
      {
        title: "Révisez les épreuves propres à l'examen Taxi",
        image: "vtc-elearning2.webp",
        alt: "Préparation à l'examen Taxi et aux matières spécifiques en ligne",
        copy: "La <strong>préparation à l'examen Taxi</strong> reprend la réglementation T3P, la gestion, la sécurité routière, le français et l'anglais. Elle approfondit surtout les matières spécifiques au taxi : réglementation nationale de l'activité, gestion propre à la profession, connaissance du territoire et réglementation locale. Les séquences vous préparent aux QCM et QRC avant le travail pratique autour d'une course de taxi.",
        detail:
          "Le contenu tient compte du rôle particulier du conducteur de taxi : prise en charge sur la voie publique, tarification, équipements obligatoires et connaissance de la zone d'activité. La préparation ne présente donc pas le programme comme une simple déclinaison du VTC. Elle met l'accent sur les règles, les repères territoriaux et les situations professionnelles propres au taxi.",
        bullets: [
          "Tronc commun de l'examen T3P",
          "Réglementation nationale et gestion de l'activité taxi",
          "Connaissance du territoire et réglementation locale",
        ],
      },
    ],
    ctaTitle: "Préparez votre examen Taxi dès maintenant",
    ctaCopy:
      "Choisissez la formation Taxi en ligne à 549 €, avec un paiement possible en 4 × 137,25 € sans frais.",
    secondFeatures: [
      {
        title: "Multipliez les entraînements sans alourdir vos révisions",
        image: "vtc-elearning3.webp",
        alt: "QCM et jeux pédagogiques de la formation Taxi e-learning",
        copy: "Alternez QCM thématiques, examens blancs et exercices chronométrés pour contrôler vos connaissances. Des jeux pédagogiques, des défis et des classements complètent le parcours afin de maintenir votre motivation. Chaque entraînement vous rapproche des conditions de l'épreuve et vous aide à mémoriser les règles utiles à la future activité de conducteur de taxi.",
        detail:
          "Les séries peuvent être utilisées de deux façons : juste après un cours pour vérifier sa compréhension, puis plusieurs jours plus tard pour contrôler la mémorisation. Les examens blancs rassemblent différentes matières et vous obligent à changer rapidement de raisonnement, comme le jour de l'admissibilité. Les corrections orientent ensuite les prochaines révisions.",
        bullets: [
          "QCM et QRC répartis par thème d'examen",
          "Examens blancs avec gestion du temps",
          "Défis pédagogiques pour réviser de façon plus active",
        ],
      },
      {
        title: "Pilotez vos révisions Taxi à partir de résultats concrets",
        image: "vtc-elearning4.webp",
        alt: "Statistiques de progression de la formation Taxi en ligne",
        copy: "Consultez vos notes, votre taux de réussite et l'évolution de vos résultats depuis un tableau de bord unique. Le détail par matière permet d'identifier rapidement une difficulté en réglementation, en gestion ou sur la connaissance du territoire. Vous consacrez alors davantage de temps aux points fragiles et avancez dans votre <strong>formation Taxi en ligne</strong> avec des objectifs précis jusqu'à l'examen.",
        detail:
          "Le suivi vous aide à éviter les révisions au hasard. Vous voyez si les résultats progressent réellement après la reprise d'un cours et si une difficulté reste ponctuelle ou récurrente. Cette lecture par matière permet de consacrer les derniers jours avant l'examen aux sujets qui peuvent encore faire gagner des points, sans délaisser les acquis déjà solides.",
        bullets: [
          "Historique des notes et des résultats obtenus",
          "Lecture de la progression par matière Taxi",
          "Priorités de révision définies à partir de vos points faibles",
        ],
      },
    ],
  },
};
